define('app/sdc/matches/sdc-matches',[],function () {
	return {
		require: "ng-model", 
		restrict:"A",
		template: null,
		scope: false,
		controller: {
			bind: {
				"getTargetValue": "&sdcMatches"
			},
			properties: {
				targetValue: function targetValue_get() {
					return this.getTargetValue();
				}
			}
		},
		link: ["$self", "$controllers", function (vm, ngModelController) {
			ngModelController.$validators.sdcMatches = function sdcMatches_validator(modelValue, viewValue) {
				if (ngModelController.$isEmpty(modelValue)) {
					return true;
				}
				else {
					return modelValue === vm.targetValue;
				}
			}
		}]
	};
});
